var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMeterIcon = function SvgMeterIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60059 52.2209V46.5093H16.8006L5.60059 52.2209Z",
    fill: "#3B8134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8006 52.2209V46.5093H33.6006L44.8006 52.2209Z",
    fill: "#3B8134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 32.2304H0V46.5093H50.4V32.2304Z",
    fill: "#3B8134"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M44.8 6.52827C44.8 3.37263 42.294 0.816711 39.2 0.816711C36.106 0.816711 33.6 3.37263 33.6 6.52827H16.8C16.8 3.37263 14.294 0.816711 11.2 0.816711C8.106 0.816711 5.6 3.37263 5.6 6.52827H0V32.2303H50.4V6.52827H44.8ZM39.2 25.0908H11.2V13.6677H39.2V25.0908Z",
    fill: "#0A9928"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMeterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "meter-icon.ade5eeee60b73a66f5139219becf9319.svg";